module.exports = __webpack_public_path__ + "static/img/18.473f457.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moho/18.png
// module id = gPDz
// module chunks = 0